import createTheme from '@mui/material/styles/createTheme';
import { breakpoints } from './theme/global/breakpoints';
import { palette } from './theme/global/palette';
import { shape } from './theme/global/shape';
import { typography } from './theme/global/typography';
// Style Overrides
import { MuiAccordion } from './theme/components/accordion';
import { MuiAccordionDetails } from './theme/components/accordionDetails';
import { MuiAccordionSummary } from './theme/components/accordionSummary';
import { MuiAlert } from './theme/components/alert';
import { MuiAlertTitle } from './theme/components/alertTitle';
import { MuiBackdrop } from './theme/components/backdrop';
import { MuiBadge } from './theme/components/badge';
import { MuiBreadcrumbs } from './theme/components/breadcrumbs';
import { MuiButton } from './theme/components/button';
import { MuiCardContent } from './theme/components/cardContent';
import { MuiCheckbox } from './theme/components/checkbox';
import { MuiChip } from './theme/components/chip';
import { MuiClock } from './theme/components/timePicker';
import { MuiClockPicker } from './theme/components/timePicker';
import { MuiClockPointer } from './theme/components/timePicker';
import { MuiCssBaseline } from './theme/global/baseLine';
import { MuiDialogActions } from './theme/components/dialogActions';
import { MuiDialogContent } from './theme/components/dialogContent';
import { MuiDialogContentText } from './theme/components/dialogContentText';
import { MuiDialogTitle } from './theme/components/dialogTitle';
import { MuiFab } from './theme/components/floatingActionButton';
import { MuiFormHelperText } from './theme/components/formHelperText';
import { MuiIconButton } from './theme/components/iconButton';
import { MuiInputAdornment } from './theme/components/inputAdornment';
import { MuiInputLabel } from './theme/components/inputLabel';
import { MuiLink } from './theme/components/link';
import { MuiListItemButton } from './theme/components/listItemButton';
import { MuiListItemIcon } from './theme/components/listItemIcon';
import { MuiMenu } from './theme/components/menu';
import { MuiMenuItem } from './theme/components/menuItem';
import { MuiOutlinedInput } from './theme/components/outlinedInput';
import { MuiPickersDay } from './theme/components/pickersDay';
import { MuiProgressIndicators } from './theme/components/progressIndicators';
import { MuiPopover } from './theme/components/popover';
import { MuiPagination } from './theme/components/pagination';
import { MuiPaginationItem } from './theme/components/paginationItem';
import { MuiRadio } from './theme/components/radio';
import { MuiSelect } from './theme/components/select';
import { MuiSlider } from './theme/components/slider';
import { MuiStepper } from './theme/components/stepper';
import { MuiSvgIcon } from './theme/components/svgIcon';
import { MuiSwitch } from './theme/components/switch';
import { MuiTab } from './theme/components/tab';
import { MuiTabs } from './theme/components/tabs';
import { MuiTextField } from './theme/components/textField';
import { MuiTooltip } from './theme/components/tooltip';
import { MuiTimePicker } from './theme/components/timePicker';
const tdcTheme = createTheme({
    palette,
    typography,
    shape,
    breakpoints,
    components: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, MuiAccordion), MuiAccordionDetails), MuiAccordionSummary), MuiAlert), MuiAlertTitle), MuiBackdrop), MuiBadge), MuiBreadcrumbs), MuiButton), MuiCardContent), MuiCheckbox), MuiChip), MuiClock), MuiClockPicker), MuiClockPointer), MuiCssBaseline), MuiDialogTitle), MuiDialogContent), MuiDialogContentText), MuiDialogActions), MuiFab), MuiFormHelperText), MuiIconButton), MuiInputLabel), MuiInputAdornment), MuiLink), MuiListItemButton), MuiListItemIcon), MuiMenu), MuiMenuItem), MuiOutlinedInput), MuiPickersDay), MuiPopover), MuiProgressIndicators), MuiPagination), MuiPaginationItem), MuiRadio), MuiSelect), MuiSlider), MuiStepper), MuiSvgIcon), MuiSwitch), MuiTooltip), MuiTab), MuiTabs), MuiTextField), MuiTimePicker),
});
export default tdcTheme;
